import { api } from "../api";
import { fromCareAssignmentToGenerated } from "../../parsers/care/to-generated/fromCareAssignmentToGenerated";
import { CareAssignment } from "../../model/patient/CareAssignment";

export const postAssignCare = async (patientId: string, careAssignment: CareAssignment) => {
  await api.services.patientCare.assignCare(patientId, fromCareAssignmentToGenerated(careAssignment));
};
